import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'xqnr-dialog-close',
    templateUrl: './dialog-close.component.pug',
    styleUrls: ['./dialog-close.component.scss'],
    standalone: false
})
export class DialogCloseComponent implements OnInit {
  @Output() close = new EventEmitter();

  constructor() {}
  ngOnInit() {}

  handleClose() {
    this.close.emit();
  }
}
